export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/CancelX.3c19b957.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};